import pdfMake from 'pdfmake';
import handlePurchase from "@/services/modules/purchase";
import pdfFonts from 'pdfmake/build/vfs_fonts';
import figureFormatter from "@/services/utils/figureFormatter";
import {ToWords} from "to-words";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const sulaimanLipiFont = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}
pdfMake.fonts = sulaimanLipiFont;

const piPdfPrint = () => {
    const {commaFormat} = figureFormatter();
    const {formatCurrency} = handlePurchase();
    const exportToPDF = (company, invoice, barcode = '', qrcode, userName, btnFunc, invoiceNotes = [], customizationFields = []) => {
        pdfMake.fonts = sulaimanLipiFont;
        const tableItems = invoice.has_item_detail ? invoice.general : invoice.ledgers;
        var doc = {
            pageSize: 'A4',
            pageMargins: [ 60, 100, 60, 80 ],
            header: getHeader(company, customizationFields),
            footer: getFooter(userName, qrcode, customizationFields),
            content: getContent(invoice, tableItems, barcode, btnFunc, invoiceNotes, customizationFields),

            styles : {
                header: {
                    fontSize: 24,
                },
                ...(btnFunc == 1 && {
                    tableExample: {
                        fontSize: 8
                    }
                })
            },
            defaultStyle: {
                color: 'black',
                fontSize: 10,
                font: 'SulaimanLipi'
            },
            info: {
                title: invoice.bill_number
            }
        }

        pushIntoTable(doc, invoice, tableItems, btnFunc, customizationFields)

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }
    const formatDate = (date) => {
        var formattedDate = date.toISOString().split('T')[0];
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var amOrPm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        var formattedTime = hours + ':' + (minutes < 10 ? '0' : '') + minutes + ' ' + amOrPm;
        return formatToDdMmYy(formattedDate) + ' ' + formattedTime
    }
    const formatToDdMmYy = (date) => {
        var dat = date.split('-');
        return `${dat[2]}-${dat[1]}-${dat[0]}`;
    }
    const getHeader = (company, customizationFields) => {
        return {
            margin: [ 60, 25, 60, 10 ],
            columns: [
                customizationFields['heading_left_logo'] && company.logo64
                    ? {
                        alignment: 'left',
                        image: company.logo64,
                        maxHeight: 60
                    }
                    : null,

                {
                    alignment: 'right',
                    stack: [
                        (customizationFields['heading_right_company_name'] && company.name) ? company.name : '',
                        (customizationFields['heading_right_company_address'] && company.address) ? 'Address: ' + company.address : '',
                        (customizationFields['heading_right_company_phone'] && company.phone) ? 'Phone: ' + company.phone : '',
                        (customizationFields['heading_right_company_email'] && company.email) ? 'E-mail: ' + company.email : '',
                        (customizationFields['heading_right_vat_reg_number'] && company.vat_no) ? 'VAT Reg No: ' + company.vat_no : '',
                    ]
                }
            ]
        }
    }
    const getContent = (invoice, tableItems, barcode, btnFunc, invoiceNotes, customizationFields) => {
        const profileItems = invoice.contact ? invoice.contact.profile_items : [];

        return  [
            {
                text: (btnFunc == 1) ? 'Proforma Invoice (PI)' : 'DELIVERY CHALLAN',
                style: 'header',
                alignment: 'center',
                margin: [0, 0, 20, 0],
                bold: true,
                color: 'black',
            },

            {
                margin: [0, 10, 0, 0],
                alignment: 'justify',
                columns: [
                    {
                        width: '50%',
                        stack: [
                            (customizationFields['body_top_left_contact_name'] && invoice.contact) ? {
                                text: 'Customer Details: ' +  invoice.contact.name,
                                color: 'black',
                                bold: true,
                            } : '',

                            (customizationFields['body_top_left_address']) ? {
                                text:  getProfileItemByField(profileItems, 'address'),
                            } : '',

                            (customizationFields['body_top_left_billing_address']) ? {
                                text:  getProfileItemByField(profileItems, 'billing_address'),
                            } : '',

                            (customizationFields['body_top_left_contact_address'] && invoice.contact && invoice.contact.address) ? {
                                text: invoice.contact.address,
                            } : '',

                            (customizationFields['body_top_left_sales_person'] && invoice.sales_person) ? {
                                text: 'Sale Person: ' +  invoice.sales_person.name,
                                color: 'black',
                                bold: true,
                            } : '',

                            (customizationFields['body_top_left_buyer_name'] && invoice.buyer) ? {
                                    text: 'Buyer Name: ' +  invoice.buyer.name,
                                    color: 'black',
                                    bold: true,
                            } : '',

                            (customizationFields['body_top_left_country'] && invoice.country) ? {
                                text: 'Country Of Origin: ' +  invoice.country,
                                color: 'black',
                                bold: true,
                            } : '',

                            (customizationFields['body_top_left_loading_port'] && invoice.loading_port) ? {
                                text: 'Loading Port: ' +  invoice.loading_port,
                                color: 'black',
                                bold: true,
                            } : '',

                            (customizationFields['body_top_left_delivery_port'] && invoice.delivery_port) ? {
                                text: 'Delivery Port: ' +  invoice.delivery_port,
                                color: 'black',
                                bold: true,
                            } : '',
                        ]
                    },

                    {
                        alignment: 'right',
                        stack: [
                            (barcode && customizationFields['body_top_right_bill_number']) ? {
                                text: [
                                    {
                                        text: (btnFunc == 1) ? 'INVOICE REF: ' : 'CHALLAN NO: ',
                                        bold: true,
                                        margin: [0, 0, 10, 0]
                                    },
                                    {
                                        text: invoice.bill_number ?? '-'
                                    }
                                 ]
                            } : '',

                            barcode ? {
                                svg: barcode
                            } : '',

                            (btnFunc == 1) ? '' : {
                                stack: [
                                    {
                                        text: invoice.location_id ? 'SHIP FROM:' : '',
                                        bold: true
                                    },
                                    {
                                        text: invoice.location_id ?? '-'
                                    }
                                ]
                            },

                            (customizationFields['body_top_right_bill_number']) ? {
                                text: [
                                    {
                                        text: 'PI No: ',
                                        bold: true,
                                        margin: [0, 0, 10, 0]
                                    },
                                    {
                                        text: invoice.bill_number ?? '-',
                                    }
                                 ]
                            } : '',

                            (customizationFields['body_top_right_date']) ? {
                                text: [
                                    {
                                        text: 'DATE: ',
                                        bold: true,
                                        margin: [0, 0, 10, 0]
                                    },
                                    {
                                        text: formatToDdMmYy(invoice.date ?? new Date()),
                                    }
                                 ]
                            } : '',

                            (customizationFields['body_top_right_order_number'] && invoice.order_number) ? {
                                text: [
                                    {
                                        text: 'Quotation Ref & Date: ',
                                        bold: true,
                                        margin: [0, 0, 10, 0]
                                    },
                                    {
                                        text: invoice.order_number,
                                    }
                                ],
                            } : '',

                            (customizationFields['body_top_right_currency'] && invoice.currency) ? {
                                text: [
                                    {
                                        text: 'Currency: ',
                                        bold: true,
                                        margin: [0, 0, 10, 0]
                                    },
                                    {
                                        text: invoice.currency,
                                    }
                                ],
                            } : '',
                        ]
                    },
                ]
            },

            {
                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    widths: (btnFunc == 1) ? getPiTableWidth(customizationFields) : ['*', 'auto', 'auto', 'auto'],
                    body: []
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex === 0) ? '#f3f2f7' : null;
                    },
                    hLineWidth: function (i, node) {
                        return 0.5;
                    },
                    vLineWidth: function (i, node) {
                        return 0.5;
                    }
                }
            },

            {
                columns: [
                    (customizationFields['body_bottom_in_words_amount']) ? {
                        width: '65%',
                        style: 'tableExample',
                        text: [
                            {
                                text: 'In Words: ',
                                bold: true
                            },
                            {
                                text: invoice.total_amount 
                                        ? currencyToWord(invoice.total_amount, false, false, 2) + ' ' + (invoice.currency ? invoice.currency : '')
                                        : ''
                            }
                        ]
                    } : '',

                    (btnFunc == 1 && formatTotals(invoice, customizationFields).length > 0) ? {
                        style: 'tableExample',
                        table: {
                            widths: ['*', '*'],
                            alignment: 'right',
                            body: formatTotals(invoice, customizationFields)
                        },
                        layout: {
                            hLineWidth: function (i, node) {
                                return 0.5;
                            },
                            vLineWidth: function (i, node) {
                                return 0.5;
                            }
                        }
                    } : ''
                ],
                margin: [0, 10]
            },

            (customizationFields['body_bottom_terms_condition'] && invoice.description) ? {
                alignment: 'justify',
                text: [{ text:'TERMS & CONDITION: \n', bold: true}, {text: invoice.description} ]
            } : '',

            invoiceNotes.length ? {
                alignment: 'left',
                stack: formatInvoiceTerms(invoiceNotes)
            } : ''
        ]
    }

    const getPiTableWidth = (customizationFields) => {
        let width = [];
        if (customizationFields['body_table_sl']) {
            width.push('auto');
        }
        if (customizationFields['body_table_style']) {
            width.push('auto');
        }
        if (customizationFields['body_table_po_number']) {
            width.push('auto');
        }
        width =  width.concat(['auto']);
        if (customizationFields['body_table_color']) {
            width.push('auto');
        }

        if (customizationFields['body_table_size']) {
            width.push('auto');
        }

        if (customizationFields['body_table_note']) {
            width.push(25);
        }

        if (customizationFields['body_table_uom']) {
            width.push('auto');
        }
        width =  width.concat(['auto', '*', '*']);
        return width;
    }

    const currencyToWord = (value, currencyShow = true, ignoreZeroCurrency = false) => {
        value = Number(Number(value).toFixed(2));

        const toWords = new ToWords({
            localeCode: 'en-BD',
            converterOptions: {
                currency: currencyShow,
                ignoreDecimal: false,
                ignoreZeroCurrency: ignoreZeroCurrency,
                doNotAddOnly: false,
            }
        });

        return toWords.convert(value);
    };

    const getFooter = (userName, qrcode, customizationFields) =>{
        return {
            margin: [ 60, 0, 60, 0 ],
            columns: [
                {
                    columns: [
                        (customizationFields['footer_qrcode']) ? {
                            svg: qrcode
                        } : '',

                        (customizationFields['footer_note']) ? {
                            width: '90%',
                            alignment: 'left',
                            text: 'N.B: This is a system generated documents and requires no manual signature.',
                            margin: [5, 53, 0, 0],
                            fontSize: 8
                        } : ''
                    ]
                },

                (customizationFields['footer_printed_by']) ? {
                    width: '20%',
                    alignment: 'right',
                    fontSize: 8,
                    margin: [0, 33, 0, 0],
                    stack: [
                        {
                            text: 'Printed by',
                            bold: true
                        },
                        {
                            text: userName
                        },
                        {
                            text: formatDate(new Date())
                        }
                    ]
                } : ''
            ]
        }
    }

    const getProfileItemByField = (profile_items, keyValue) => {
        const item = profile_items.find(item => item.field === keyValue);
        return (item) ? item.value : '';
    }

    const formatTotals = (invoice, customizationFields) => {
        const totals = [];

        if (customizationFields['body_totals_table_subtotal_amount']) {
            totals.push([
                { text: 'Sales Amount' },
                { text: commaFormat(invoice.subtotal_amount), alignment: 'right' }
            ]);
        }

        if (customizationFields['body_totals_table_total_amount']) {
            totals.push([
                { text: 'Total Invoice Amount', bold: true },
                { text: commaFormat(invoice.total_amount), alignment: 'right' }
            ]);
        }

        if (invoice.vat_amount > 0 && customizationFields['body_totals_table_vat_amount']) {
            totals.push([
                { text: 'VAT Amount' },
                { text: commaFormat(invoice.vat_amount), alignment: 'right' }
            ]);
        }

        if (invoice.paid_amount && customizationFields['body_totals_table_paid_amount']) {
            totals.push([
                { text: 'Amount Paid', bold: true },
                { text: commaFormat(invoice.paid_amount), alignment: 'right' }
            ]);
            totals.push([
                { text: 'Total Payable', bold: true },
                { text: commaFormat(invoice.total_amount - invoice.paid_amount), alignment: 'right' }
            ]);
        }

        return totals.length > 0 ? totals : [];
    };

    const formatInvoiceTerms = (terms) => {
        return  terms.map((item, index) => {
            return {
                text: `${item.full_desc}`
            }
        })
    }

    let srNumber = 0;
    const pushIntoTable = (doc, invoice, tableItems, btnFunc, customizationFields) => {
        srNumber = 0;
        var flag = false;
        tableItems.forEach(item => {
            if( !flag ){
                const tableHeader = getTableHeader(btnFunc, customizationFields);
                doc.content[2].table.body.push(tableHeader);
                flag = true;
            }
            const rowData = getRowData(invoice, item, btnFunc, customizationFields);
            return doc.content[2].table.body.push(rowData);
        });
    }
    const getTableHeader = (btnFunc, customizationFields) => {
        let headerInvoice = [];
        if (customizationFields['body_table_sl']) {
            headerInvoice.push({ text: 'SL #' });
        }
        if (customizationFields['body_table_style']) {
            headerInvoice.push({ text: 'Style' });
        }
        if (customizationFields['body_table_po_number']) {
            headerInvoice.push({ text: 'PO Number' });
        }

        headerInvoice = headerInvoice.concat([
            { text: 'Item' },
        ])

        if (customizationFields['body_table_color']) {
            headerInvoice.push({ text: 'Color' });
        }
        if (customizationFields['body_table_size']) {
            headerInvoice.push({ text: 'Size' });
        }
        if (customizationFields['body_table_note']) {
            headerInvoice.push({ text: 'Note' });
        }
        if (customizationFields['body_table_uom']) {
            headerInvoice.push({ text: 'UoM' });
        }
        headerInvoice = headerInvoice.concat([
            { text: 'Qty' },
            { text: 'Unit Price', alignment: 'right' },
            { text: 'Total Amount', alignment: 'right' }
        ])

        let headerChallan = [
            { text: 'PARTICULARS' },
            { text: 'UNIT', alignment: 'left' },
            { text: 'DELIVERY QTY', alignment: 'right' },
            { text: 'REMARKS' }
        ]

        return (btnFunc == 1) ? headerInvoice : headerChallan;
    }

    const getRowData = (invoice, item, btnFunc, customizationFields) => {
        srNumber += 1;

        let finaTotalAmount = item.total_amount

        if (!invoice.has_item_detail){
            finaTotalAmount = item.credit - item.discount_amount + item.vat_amount
        }

        const productNameValue = getSpecificationName(item, 0);
        const colorName = getSpecificationName(item, 1);
        const sizeName = getSpecificationName(item, 2);
        const unitNameValue = unitName(item);

        let piInvoiceData = [];
        if (customizationFields['body_table_sl']) {
            piInvoiceData.push({ text: srNumber });
        }
        if (customizationFields['body_table_style']) {
            piInvoiceData.push({ text: (invoice.has_item_detail ? item.style : '-') });
        }
        if (customizationFields['body_table_po_number']) {
            piInvoiceData.push( { text: (invoice.has_item_detail ? item.po_number : '-') });
        }
        piInvoiceData = piInvoiceData.concat([
            { text: productNameValue },
        ]);
        if (customizationFields['body_table_color']) {
            piInvoiceData.push( { text: colorName });
        }
        if (customizationFields['body_table_size']) {
            piInvoiceData.push( { text: sizeName });
        }
        if (customizationFields['body_table_note']) {
            piInvoiceData.push( { text: item.description });
        }
        if (customizationFields['body_table_uom']) {
            piInvoiceData.push( { text: unitNameValue });
        }
        piInvoiceData = piInvoiceData.concat([
            { text: invoice.has_item_detail ? item.quantity : '', alignment: 'right' },
            { text: invoice.has_item_detail ? formatCurrency(item.rate) : '', alignment: 'right' },
            { text: commaFormat(finaTotalAmount), alignment: 'right' }
        ]);

        return (btnFunc == 1) ? piInvoiceData :

        [
            { text: productNameValue + '\n' + (item.description ? item.description : '') },
            { text: item.product ? unitNameValue : '' },
            { text: invoice.total_quantity, alignment: 'right' },
            { text: '' }
        ]
    }

    const getSpecificationName = (item, index) => {
        if (item && item.product && item.product.specifications && item.product.specifications[index] && item.product.specifications[index].specifiable && item.product.specifications[index].specifiable.name) {
            return item.product.specifications[index].specifiable.name;
        }
        return '-';
    }

    const unitName = (item) => {
        if (item && item.product && item.product.description && item.product.description.unit && item.product.description.unit.name) {
            return item.product.description.unit.name;
        }
        return item.head.name;
    }

    const productName = (item) => {
        if (item && item.product && item.product.name) {
            return item.product.name;
        }
        return item.head.name;
    }

    return {
        exportToPDF
    }
}

export default piPdfPrint;
